module.exports = {
  MenuManagement: 'Управление меню',
  CustomerMenu: 'Клиентское меню',
  CustomerAutomation: 'Автоматизация клиентов',
  Search: 'Поиск',
  PleaseEnterChinese: 'Введите текст на китайском, английском или код',
  AddMenu: 'Добавить меню',
  UpdateMenu: 'Редактировать меню',
  AddCustomerMenu: 'Добавить клиентское меню',
  Refresh: 'Обновить',
  ChineseName: 'Название на китайском',
  EnglishName: 'Название на английском',
  Coding: 'Код',
  Icon: 'Иконка',
  Node: 'Узел',
  ParentNode: 'Родительский узел',
  Order: 'Порядок',
  ModuleFile: 'Файл модуля',
  H5Url: 'H5-адрес',
  Type: 'Тип',
  Module: 'Модуль',
  Component: 'Компонент',
  Add: 'Добавить',
  Update: 'Редактировать',
  Save: 'Сохранить',
  Cancel: 'Отмена',
  OK: 'Подтвердить',
  ChineseCanNotBeEmpty: 'Поле на китайском не может быть пустым',
  EnglishCanNotBeEmpty: 'Поле на английском не может быть пустым',
  TheEncodingCanNotBeEmpty: 'Поле кода не может быть пустым',
  SavedSuccess: 'Успешно сохранено',
  PleaseSelectTheMenu: 'Выберите меню',
  PleaseSelectTheCustomer: 'Выберите клиента',
  NoCustomersWantToAdd: 'Нет клиентов для добавления',
  Prompt: 'Подсказка',
  Removed: 'Удалить',
  Numbering: 'Номер',
  delete: 'Удалить',
  CompanyChineseName: 'Название на китайском',
  SuccessfullyDeleted: 'Успешно удалено',
  DeleteData: 'Выберите клиентов для удаления',
  UpdateData: 'Выберите клиента для редактирования',
  InitData: 'Выберите клиента для просмотра базовых данных',
  SearchTitle: 'Введите название компании или код для поиска',
  BasicData: 'Базовые данные',
  ExpiredCustomerNotification: 'Уведомление об истечении срока клиента',
  CompanyName: 'Название компании',
  CompanyCode: 'Код компании',
  CompanyPhone: 'Телефон компании',
  CompanyEMail: 'Email компании',
  CompanyFax: 'Факс компании',
  CreateDate: 'Время создания',
  GroupCompany: 'Группа компаний',
  InitializeCustomer: 'Зарегистрированная компания',
  copy: 'Выберите среду для копирования',
  InitializeData: 'Инициализация базовых данных',
  InitializeMenu: 'Инициализация меню',
  CompanyNamePrompt: 'Название компании обязательно',
  mailbox: 'Email администратора обязателен',
  UpdateSuccess: 'Информация успешно изменена',
  Initialized: 'Инициализация успешно завершена',
  CompanyAddress: 'Адрес компании',
  AdminChineseName: 'Имя администратора на китайском',
  AdminEnglishName: 'Имя администратора на английском',
  email: 'Email администратора',
  phone: 'Телефон администратора',
  Current: 'Код компании',
  StandardLibrary: 'Стандартная среда',
  Next: 'Далее',
  Back: 'Назад',
  Finish: 'Завершить',
  Initialize: 'Инициализация',
  Harbour: 'Морской порт',
  Airport: 'Аэропорт',
  ChargesItems: 'Платные услуги',
  AirRoute: 'Маршрут',
  NetWork: 'Сеть',
  Currency: 'Валюта',
  EQType: 'Тип контейнера',
  Packing: 'Упаковка',
  HouseBlType: 'Тип коносамента',
  CargoType: 'Тип груза',
  IncoTerm: 'Торговые условия',
  ShippingTerm: 'Транспортные условия',
  TradeTerm: 'Способ торговли',
  CustomerType: 'Тип клиента',
  PortGroup: 'Связанные порты',
  OtherChargeItem: 'Дополнительные сборы авианакладной',
  ShippingCompaniesAirlines: 'Судоходная компания, авиакомпания',
  Template: 'Шаблон',
  AirService: 'Услуги авиаперевозки',
  BlMode: 'Способ коносамента',
  CustomJobType: 'Пользовательский тип бизнеса',
  TransmitFileType: 'Тип циркулирующего документа',
  copyTenantId: 'Выберите среду для копирования',
  imgToolTip: 'Заполните информацию о компании и системном администраторе\nEmail администратора является учетными данными для входа',
  imgToolTip2: 'Шаблоны для копирования',
  imgToolTip3: 'Базовые данные платформы',
  imgToolTip4: 'Меню платформы',
  Sequence: 'Последовательность',
  documentCategory: 'Управление типами файлов',
  charegeUnit: 'Единица тарификации / Единица',
  BusinessStatus: 'Управление статусом услуг',
  PermissionConfig: 'Настройка прав доступа',
  Report: 'Отчеты',
  ConfigurationManagement: 'Управление конфигурацией',
  SingleOnlineSet: 'Настройка онлайн-сверки',
  IsH5Open: 'Открыт ли H5',
  CopySetting: 'Копирование конфигурации',
  AllOpen: 'Открыть все',
  AllClose: 'Закрыть все',
  Start: 'Начать',
  StandardLibrary2: 'Стандартная библиотека',
  OnlineCustomerService: 'Онлайн-поддержка',
  SubmitATicket: 'Отправить заявку',
  CheckTheTicket: 'Просмотр заявок',
  Menu1: 'Меню',
  HelpCenter: 'Центр помощи',
  HelpVideo: 'Обучающие видео',
  SystemOperationGuidance: 'Руководство по работе с системой',
  InitializeBoot: 'Руководство по инициализации',
  SpareQQ: 'Резервный QQ',
  SettingsAndTools: 'Настройки и инструменты',
  ReportStatistics: 'Статистика отчетов',
  Weibo: 'Weibo',
  LogInformation: 'Информация журнала',
  BillingSystem: 'Тарификационная система',
  UnbindWeChat: 'Отвязать WeChat',
  SystemInformation: 'Системная информация',
  SignOut: 'Выйти',
  WallTechFamily: 'Woxing Home',
  Notice: 'Напоминание',
  ClearLog: 'Очистить журнал',
  UploadLog: 'Загрузить журнал',
  AuthorizationToken: 'Токен авторизации:',
  LogLevel: 'Уровень журнала:',
  Source: 'Источник',
  AccountInformation: 'Информация об аккаунте',
  ShowYourAccountNumberAndTheCompaniesAndDepartmentsToWhichYouBelongHere: 'Здесь отображается ваш аккаунт, компания и отдел',
  InStationMessageReminder: 'Уведомления на сайте',
  WhenYouHaveAPendingTaskThereWillBeAToDoNumberOnTheBellToRemindYouToDealWithItInTime: 'При наличии невыполненных задач на значке колокольчика будет отображаться их количество',
  ClickHereToEnterWallTechFamilyToViewYourOrderTrainingVideosAndOtherInformation: 'Нажмите здесь, чтобы перейти в Woxing Home и просмотреть заказы, обучающие видео и другую информацию',
  WhenYouEncounterProblemsWithYourOperatingSystemYouCanContactOurOnlineCustomerServiceAtAnyTime: 'При возникновении проблем с системой вы можете связаться с нашей онлайн-поддержкой',
  MultilingualSwitching: 'Переключение языка',
  SwitchDifferentLanguages: 'Смена языка',
  HereIsAHelpfulCenterSystemRelatedConfigurationToolsReportStatisticsBillingSystemAndOtherMoreInformation: 'Здесь находится центр помощи, инструменты настройки системы, статистика отчетов, тарификационная система и другая информация',
  OperationArea: 'Рабочая область',
  HereIsTheOperationInterfaceForYourDailyWork: 'Здесь находится интерфейс для вашей повседневной работы',
  MenuBar: 'Панель меню',
  TheSystemModuleMenuBarDisplayedHereMatchesThePermissionsOfYourLoginAccount: 'Здесь отображается панель меню системных модулей, соответствующих правам вашего аккаунта',
  More: 'Еще',
  Skip: 'Пропустить',
  WeChatUnbindingFailed: 'Не удалось отвязать WeChat',
  WhetherToConfirmWeChatUnbinding: 'Подтверждаете отвязку WeChat?',
  Unbind: 'Отменить отвязку',
  WeChatUnbindingSuccessfully: 'WeChat успешно отвязан',
  DearYouHaventBoundYourWeChatAccountYet: 'Уважаемый, вы еще не привязали WeChat',
  AdministratorInitializationOperationGuidance: 'Руководство по начальной настройке для администратора',
  ImproveEnterpriseInformation: 'Заполнение информации о компании',
  PleaseImproveYourCompanyEnterpriseInformation: 'Пожалуйста, заполните информацию о вашей компании',
  CreateAUser: 'Создание пользователя',
  CreateOurUsersAndSetPermissions: 'Создание пользователей компании и настройка прав доступа',
  CustomerDataImport: 'Импорт данных клиентов и поставщиков',
  InitializeAndImportTheCompanyOriginalCustomerInformation: 'Первоначальный импорт существующих данных клиентов и поставщиков компании',
  ViewTheSteps: 'Просмотр шагов выполнения',
  YouAreNotAuthorizedToUseStatisticalAnalysisFunction: 'У вас нет прав на использование функции статистического анализа'
}
